import { Directive, ElementRef, Input } from '@angular/core';
import flowplayer from 'flowplayer';

@Directive({
  selector: '[appFlowplayer]'
})
export class FlowplayerDirective {
  constructor(el: ElementRef) {
    const container = el.nativeElement;

    flowplayer.conf = {
      key: '$151175528150992',
      logo: false,
      embed: false,
      share: false,
      disabled: false,
      advance: true,
      loop: false,
      splash: false,
    };

    flowplayer(container, {
      clip: {
        sources: [
          { type: 'video/webm',
            src:  '//universarium.gcdn.co/video_fragments/9987/webm/FundamentalsofAES2006technology31_720p.webm' },
          { type: 'video/mp4',
            src:  '//universarium.gcdn.co/video_fragments/9987/mp4/FundamentalsofAES2006technology31_720p.mp4' }
        ]
      }
    });
  }
}



// WEBPACK FOOTER //
// /var/www/ras.universarium.org/www/src/app/flowplayer/flowplayer.directive.ts